import {
  Button,
  Col, Divider,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../app/store'
import { changePassword } from '../features/personalManagement/personalDetail/personalDetailSlice'
import styles from './Layout.module.css'
import {useHistory} from "react-router-dom";
export const TimeUpMessageModal = (props: {
  isModalVisible: boolean
  message:any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()
  const history = useHistory()


  return (
    <Modal
      className={styles.timeUpModal}
      onCancel={() => {
        props?.onCancel()
      }}
      footer={null}
      visible={props.isModalVisible}
      title={props?.message?.[0]?.title}
      width='650px'
    >
      {props.message.map((v: any) => {
        return (
          <div key={v.id}>
            <div style={{ fontSize: 14 }}>{v.content}</div>
            {v?.innerUrl ? <Button type='link' style={{ paddingLeft: 0 }} onClick={() => {
              history.push({
                pathname: v?.innerUrl,
              })
            }}>查看详情</Button> : ''}
          </div>
        )
      })}
      <Row
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px',
          marginRight: '24px',
        }}
      >
        <Button
          onClick={() => {
            props?.onCancel()
          }}
        >
          我知道了
        </Button>
      </Row>

    </Modal>
  )
}
